var AJAXINATE_STATE_KEY = 'ajaxinate:collection-state';
var AJAXINATE_LOADER =
  '<div class="code-loader" aria-hidden="true"><div></div><div></div><div></div></div>';

function getGridItemLinks(container) {
  return Array.from(container.querySelectorAll(':scope > li'))
    .map(function (li) {
      var link = li.querySelector('a[href]');
      return link ? link.getAttribute('href') : null;
    })
    .filter(Boolean);
}

function getAjaxinateStateKey() {
  return window.location.pathname + window.location.search;
}

function isBackForwardNavigation() {
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav) return nav.type === 'back_forward';
    return performance.navigation && performance.navigation.type === 2;
  } catch (e) {
    return false;
  }
}

function readAjaxinateState() {
  try {
    var raw = sessionStorage.getItem(AJAXINATE_STATE_KEY);
    if (!raw) return null;
    var state = JSON.parse(raw);
    if (!state || state.key !== getAjaxinateStateKey()) return null;
    return state;
  } catch (e) {
    return null;
  }
}

function saveAjaxinateState() {
  var grid = document.getElementById('product-grid');
  if (!grid || !grid.children.length) return;

  var pagination = document.getElementById('AjaxinatePagination');
  var state = {
    key: getAjaxinateStateKey(),
    scrollY: window.scrollY,
    gridHTML: grid.innerHTML,
    paginationHTML: pagination ? pagination.innerHTML : '',
    hasSentinel: !!pagination
  };

  try {
    sessionStorage.setItem(AJAXINATE_STATE_KEY, JSON.stringify(state));
  } catch (e) {
    // Navigation state is optional; keep the previous snapshot if storage fails.
  }
}

function applyAjaxinateState(state) {
  var grid = document.getElementById('product-grid');
  if (!grid || !state.gridHTML) return false;

  grid.innerHTML = state.gridHTML;

  var pagination = document.getElementById('AjaxinatePagination');
  if (state.hasSentinel && pagination) {
    pagination.innerHTML = state.paginationHTML || '';
  } else if (pagination && pagination.parentNode) {
    pagination.parentNode.removeChild(pagination);
  }

  return true;
}

function revealAjaxinateGrid() {
  var hideStyle = document.getElementById('ajaxinate-hide-until-restore');
  if (hideStyle && hideStyle.parentNode) hideStyle.parentNode.removeChild(hideStyle);
}

function restoreScrollPosition(scrollY) {
  var top = parseInt(scrollY, 10) || 0;
  window.scrollTo(0, top);
  requestAnimationFrame(function () {
    window.scrollTo(0, top);
  });
}

function CustomAjaxinate(settings) {
  var defaults = { container: '#product-grid', pagination: '#AjaxinatePagination', offset: 300 };
  this.settings = Object.assign({}, defaults, settings);
  this.container = document.querySelector(this.settings.container);
  this.pagination = document.querySelector(this.settings.pagination);
  this.requestPending = false;
  this.scrollEvent = null;
  this.xhr = null;
  this.destroyed = false;

  if (this.container && this.pagination) {
    this.initialize();
  }
}

CustomAjaxinate.prototype.destroy = function () {
  this.destroyed = true;
  this.requestPending = false;
  if (this.xhr) {
    this.xhr.abort();
    this.xhr = null;
  }
  if (this.scrollEvent) {
    window.removeEventListener('scroll', this.scrollEvent);
    this.scrollEvent = null;
  }
  this.hideLoader();
};

CustomAjaxinate.prototype.showLoader = function () {
  if (!this.pagination || this.pagination.querySelector('.code-loader')) return;
  this.pagination.classList.add('is-loading');
  this.pagination.insertAdjacentHTML('beforeend', AJAXINATE_LOADER);
};

CustomAjaxinate.prototype.hideLoader = function () {
  if (!this.pagination) return;
  this.pagination.classList.remove('is-loading');
  var loader = this.pagination.querySelector('.code-loader');
  if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
};

CustomAjaxinate.prototype.finishLoading = function () {
  this.requestPending = false;
  this.hideLoader();
};

CustomAjaxinate.prototype.initialize = function () {
  if (this.destroyed) return;
  this.extendedPagination = this.pagination.querySelector('#AjaxinateTargetLink');
  if (this.extendedPagination) {
    this.nextPageUrl = this.extendedPagination.href;
    this.bindScroll();
  }
};

CustomAjaxinate.prototype.bindScroll = function () {
  var self = this;

  if (this.destroyed) return;

  if (this.scrollEvent) {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  this.scrollEvent = function () {
    if (self.destroyed || self.requestPending) return;

    var rect = self.container.getBoundingClientRect();
    var nearContainerBottom = rect.bottom <= window.innerHeight + self.settings.offset;

    if (nearContainerBottom) {
      if (!self.nextPageUrl) {
        self.destroy();
        return;
      }
      self.requestPending = true;
      self.showLoader();
      self.loadPage();
    }
  };

  window.addEventListener('scroll', this.scrollEvent, { passive: true });
  this.scrollEvent();
};

CustomAjaxinate.prototype.loadPage = function () {
  var self = this;
  if (this.destroyed || !this.nextPageUrl) return;

  var xhr = new XMLHttpRequest();
  this.xhr = xhr;
  this.showLoader();

  xhr.open('GET', this.nextPageUrl);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4 || xhr._ajaxinateDone) return;
    xhr._ajaxinateDone = true;
    if (self.destroyed) return;

    if (xhr.status !== 200) {
      self.finishLoading();
      return;
    }

    var doc = new DOMParser().parseFromString(xhr.responseText, 'text/html');
    var incomingContainer = doc.querySelector(self.settings.container);
    var incomingPagination = doc.querySelector(self.settings.pagination);
    var existingLinks = getGridItemLinks(self.container);

    if (incomingContainer && incomingContainer.innerHTML.trim() !== '') {
      var parserDiv = document.createElement('div');
      parserDiv.innerHTML = incomingContainer.innerHTML;
      var incomingItems = parserDiv.querySelectorAll(':scope > li');
      var hasDuplicates = false;

      if (incomingItems.length > 0) {
        var firstIncomingLink = incomingItems[0].querySelector('a[href]');
        if (firstIncomingLink && existingLinks.includes(firstIncomingLink.getAttribute('href'))) {
          hasDuplicates = true;
        }
      }

      if (hasDuplicates) {
        self.destroy();
        self.pagination.innerHTML = '';
        self.finishLoading();
        return;
      }

      var urlObj = new URL(self.nextPageUrl, window.location.origin);
      var pageNum = urlObj.searchParams.get('page') || '1';
      Array.from(incomingContainer.children).forEach(function (child) {
        child.setAttribute('data-page-index', pageNum);
      });

      self.container.insertAdjacentHTML('beforeend', incomingContainer.innerHTML);
    }

    var incomingLink = incomingPagination ? incomingPagination.querySelector('#AjaxinateTargetLink') : null;

    if (!incomingPagination || !incomingLink || incomingLink.href === self.nextPageUrl) {
      self.destroy();
      self.pagination.innerHTML = '';
      self.finishLoading();
      window.dispatchEvent(new Event('scroll'));
      return;
    }

    self.pagination.innerHTML = incomingPagination.innerHTML;
    self.finishLoading();
    self.initialize();
    window.dispatchEvent(new Event('scroll'));
  };
  xhr.onerror = function () {
    if (self.destroyed) return;
    self.finishLoading();
  };
  xhr.send();
};

var ajaxinateInstance = null;
var paginationIndicatorInitialized = false;

window.runAjaxinateEngine = function () {
  var grid = document.getElementById('product-grid');
  var pagination = document.getElementById('AjaxinatePagination');
  if (!grid || !pagination) return;

  if (ajaxinateInstance) {
    ajaxinateInstance.destroy();
    ajaxinateInstance = null;
  }

  ajaxinateInstance = new CustomAjaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    offset: 300
  });
};

window.onProductGridUpdated = function () {
  if (ajaxinateInstance) {
    ajaxinateInstance.destroy();
    ajaxinateInstance = null;
  }

  document.querySelectorAll('#product-grid > li').forEach(function (el) {
    if (!el.getAttribute('data-page-index')) {
      el.setAttribute('data-page-index', '1');
    }
  });
  updateActivePageIndicator();
  window.runAjaxinateEngine();
};

function getPaginationPageItems() {
  var grid = document.getElementById('product-grid');
  if (!grid) return [];

  var scope = grid.closest('.collection, .template-search__results');
  if (!scope) return [];

  var list = scope.querySelector('.pagination__list');
  if (!list) return [];

  return Array.from(list.querySelectorAll('.pagination__item')).filter(function (item) {
    return /^\d+$/.test(item.textContent.trim());
  });
}

function updateActivePageIndicator() {
  var items = document.querySelectorAll('#product-grid > li[data-page-index]');
  if (items.length === 0) return;

  var currentActivePage = '1';
  var scrollPosition = window.scrollY || window.pageYOffset;
  var windowHeightHalf = window.innerHeight / 2;

  for (var i = 0; i < items.length; i++) {
    var elementTop = items[i].getBoundingClientRect().top + scrollPosition;
    if (scrollPosition + windowHeightHalf >= elementTop) {
      currentActivePage = items[i].getAttribute('data-page-index');
    }
  }

  getPaginationPageItems().forEach(function (item) {
    var isActive = item.textContent.trim() === String(currentActivePage);

    item.classList.remove('pagination__item--current', 'light');
    item.removeAttribute('aria-current');

    if (isActive) {
      item.classList.add('pagination__item--current', 'light');
      item.setAttribute('aria-current', 'page');
    }
  });
}

function initPaginationIndicator() {
  if (paginationIndicatorInitialized) return;
  paginationIndicatorInitialized = true;

  window.addEventListener('scroll', updateActivePageIndicator);
  setTimeout(updateActivePageIndicator, 500);
}

function initAjaxinate() {
  var restoredState = null;

  if (!window.ajaxinateStateApplied) {
    window.ajaxinateStateApplied = true;
    if (isBackForwardNavigation()) {
      restoredState = readAjaxinateState();
      if (restoredState) applyAjaxinateState(restoredState);
    }
  }

  initPaginationIndicator();
  window.onProductGridUpdated();

  if (restoredState) restoreScrollPosition(restoredState.scrollY);
  revealAjaxinateGrid();
}

window.initAjaxinate = initAjaxinate;

if (isBackForwardNavigation() && readAjaxinateState() && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
  if (!document.getElementById('ajaxinate-hide-until-restore') && document.head) {
    var hideStyle = document.createElement('style');
    hideStyle.id = 'ajaxinate-hide-until-restore';
    hideStyle.textContent = '#ProductGridContainer{visibility:hidden}';
    document.head.appendChild(hideStyle);
    setTimeout(revealAjaxinateGrid, 800);
  }
}

if (!window.ajaxinateStateBound) {
  window.ajaxinateStateBound = true;
  window.addEventListener('pagehide', saveAjaxinateState);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('#product-grid a[href]')) {
      saveAjaxinateState();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAjaxinate);
} else {
  initAjaxinate();
}

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('#product-grid')) {
    setTimeout(initAjaxinate, 50);
  }
});
